import PropTypes from "prop-types"
import React from 'react'
import * as S from '../styled'
import moment from 'moment'
import PurchaseOrderList from '../purchaseOrdersList'
import { Tag } from '../tag'

const CardEmergencyNegotiation = ({ data, handleClick, idCompositionSelected }) => (
  <>
    {data.map(composicao => (
      <S.Wrapper
        key={composicao.Id}
        background='#e74c3c'
        color='var(--color-contrast-white)'
        data-testid={`emergency-negotiation-${composicao.Id}`}>
        <S.Hora
          color='var(--color-contrast-white)'
        >
          {composicao && <span> {moment(composicao.Hour, "HH:mm:ss").format("HH:mm")}</span>}
        </S.Hora>
        <Tag
          data-testid={`click-emergency-negotiation-slot-${composicao.Id}`}
          onClick={handleClick ? () => handleClick(composicao) : undefined}
          status={composicao.Situation}
        />
        <S.Content color='var(--color-contrast-white)'>
          <PurchaseOrderList loadComposition={composicao} />
        </S.Content>
      </S.Wrapper>
    ))}
  </>
)

CardEmergencyNegotiation.propTypes = {
  data: PropTypes.shape({
    map: PropTypes.func
  }).isRequired,
  handleClick: PropTypes.func.isRequired,
  idCompositionSelected: PropTypes.any.isRequired
}

export default CardEmergencyNegotiation;
